// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/_css-loader@0.28.11@css-loader/index.js!../../../node_modules/_sass-loader@6.0.7@sass-loader/lib/loader.js!./basic.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/_vue-style-loader@3.1.2@vue-style-loader/lib/addStylesClient.js")("3f60e64d", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/basic.scss
// module id = 29
// module chunks = 0